"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = Page;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _layout = require("../layout");
var _CredentialsForm = require("./CredentialsForm");
var _TwoFactor = require("../TwoFactor");
var _ui = require("../../ui");
var _hooks = require("../../../hooks");
var _state = require("../../../state");
var _excluded = ["setFirstStep"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Page(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('libAuth'),
    t = _useTranslation.t;
  var _useLoginWizard = (0, _hooks.useLoginWizard)(),
    setFirstStep = _useLoginWizard.setFirstStep,
    wizardProps = _objectWithoutProperties(_useLoginWizard, _excluded);
  var _useLogin = (0, _state.useLogin)(),
    loginWithCredentials = _useLogin.loginWithCredentials,
    loginWithEmail2fa = _useLogin.loginWithEmail2fa,
    loginWithTotp = _useLogin.loginWithTotp,
    loading = _useLogin.loading,
    email = _useLogin.email,
    remainingTime = _useLogin.remainingTime;
  return /*#__PURE__*/_react.default.createElement(_ui.Wizard, wizardProps, /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 0
  }, /*#__PURE__*/_react.default.createElement(_layout.LayoutTitle, null, t('login'))), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 1
  }, /*#__PURE__*/_react.default.createElement(_layout.LayoutBackTitle, {
    onClick: setFirstStep
  }, t('backToLogin'))), /*#__PURE__*/_react.default.createElement(_layout.LayoutBodyCard, null, /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 0
  }, /*#__PURE__*/_react.default.createElement(_CredentialsForm.CredentialsForm, {
    onSubmit: loginWithCredentials,
    submitLoading: loading,
    remainingTime: remainingTime,
    forgotPasswordLink: props.forgotPasswordLink,
    signUpLink: props.signUpLink
  })), /*#__PURE__*/_react.default.createElement(_ui.WizardStep, {
    order: 1
  }, /*#__PURE__*/_react.default.createElement(_TwoFactor.TwoFactor, {
    onEmailFormSubmit: loginWithEmail2fa,
    onGoogleFormSubmit: loginWithTotp,
    submitLoading: loading,
    email: email
  })))));
}